// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t6-2";
export var container = "_t6-4";
export var dismissButton = "_t6-3";
export var hasPaddingBottom = "_t6-6";
export var last = "_t6-e";
export var scrollbarThumb = "_t6-c";
export var scrollbarTrack = "_t6-b";
export var selected = "_t6-9";
export var spin = "_t6-1";
export var spinning = "_t6-0";
export var suggestionItem = "_t6-d";
export var suggestionsPanel = "_t6-5";
export var tonePill = "_t6-8";
export var tonesContainer = "_t6-7";
export var unselected = "_t6-a";